module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-base-shadow-6.79e017c1.png";